import { DeviceManifest } from '@rapoo/device-sdk'
import {
  baseChannel0To7,
  baseChildDeviceEnabled,
  baseScreenLogo,
} from './generate/capabilityPresets'
import { p8BaseLightBandEffects, p8BaseLightScreenEffects } from './generate/lightingPresets'

/**
 * ESPR7 底座设备清单
 */
const rapooESPR7: DeviceManifest = {
  channel: ['china_cybercafe'],
  model: 'ESPR7',
  mainControl: 'ESPR7',
  type: 'base',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: 0x1458,
    currentPid: 0x1458,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 14,
        description: 'Base WebHID Command Interface',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 2,
        description: 'Base Nordic Firmware Update Interface',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Base WCH Firmware Update Interface',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'VT_nrf54L_Base',
  baseDisplay: 'lighting',
  ui: {
    assetsDir: 'manifests/ESPR7',
    colors: {
      series: [
        {
          name: 'common.products.ESPR7.Emerald_Wind',
          value: '#00BFDE',
          key: 'Emerald_Wind',
        },
        {
          name: 'common.products.ESPR7.Blazing_Sun_Orange',
          value: '#EE6E40',
          key: 'Blazing_Sun_Orange',
        },
      ],
      current: 'Emerald_Wind',
    },
    icon: 'Hardware-Wireframe-Base',
    overview: true,
  },
  capabilities: [
    {
      type: 'lighting',
      config: {
        enable: true,
        effects: [...p8BaseLightBandEffects, ...p8BaseLightScreenEffects],
      },
    },
    baseScreenLogo,
    baseChannel0To7,
    baseChildDeviceEnabled,
  ],
  layout: {
    image: 'devices/base/base.png',
    keys: [],
  },
}

export default rapooESPR7
